import React from "react";
import Logo from "../Logo/Logo";
import * as F from "./Footer-style";

export default class FooterCompany extends React.Component {
   render() {
      let color = {
         colorFont: 'rgba(255, 255, 255, 1)',
         colorTriangel: 'rgba(0, 164, 229, 1)',
         fontSize: '1.43rem'
      };

      return (
         <F.FooterCompany>
            <F.FooterTitle>
               company
            </F.FooterTitle>
            <Logo options={color} />
            <div>
               Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.
            </div>
         </F.FooterCompany>
      )
   }
}